import React, { createContext, useState, useContext } from 'react';

export const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [currentLocation, setCurrentLocation] = useState('Mumbai');

  const maharashtraLocations = [
    { id: 1, name: 'Amravati', address: 'Amravati' },
    { id: 2, name: 'Akola', address: 'Akola' },
    { id: 3, name: 'Nagpur', address: 'Nagpur' },
    { id: 4, name: 'Chandrapur', address: 'Chandrapur' },
    { id: 5, name: 'Yavatmal', address: 'Yavatmal' },
    { id: 6, name: 'Gondia', address: 'Gondia' },
    { id: 6, name: 'Gadchiroli', address: 'Gadchiroli' },
    { id: 6, name: 'Wardha', address: 'Wardha' },
    { id: 6, name: 'Bhandara', address: 'Bhandara' },
    { id: 6, name: 'Buldhana', address: 'Buldhana' },
    { id: 6, name: 'Washim', address: 'Washim' },
  ];


  const changeLocation = (locationName) => {
    setCurrentLocation(locationName);
  };

  return (
    <LocationContext.Provider value={{
      currentLocation,
      maharashtraLocations,
      changeLocation
    }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};